<sib-map #mapComponent *ngIf="showMap" [overlays]="overlays" [options]="options" [allowAddMarker]="false"
    [mapFromHoarding]="mapFromHoarding" [showNotification]="showNotification" [showSearch]="false"
    [campaignTrackerMap]="campaignTrackerMap" [planTrackerMap]="planTrackerMap" [xlsxMap]="true"></sib-map>